var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8794 2.6006C13.8722 2.47803 13.8163 2.15954 13.4341 2.03748C13.4224 2.03389 13.3603 2.01389 13.256 1.98106C12.2262 1.6554 7.07637 0.0296226 7.07637 0.0296226C6.95069 -0.0103806 6.81585 -0.00986772 6.69068 0.0311612L0.530847 2.0385C0.294752 2.11543 0.124296 2.32417 0.0947838 2.57291C-0.477135 7.41073 1.56783 12.187 5.45271 15.0867L6.50801 15.874C6.72833 16.0386 7.02854 16.0422 7.25242 15.8832L8.54738 14.9636C12.4796 12.1706 14.5357 7.40099 13.8794 2.6006ZM12.6628 3.13705C13.1059 7.33893 11.2594 11.469 7.81467 13.9159C7.43916 14.1826 7.12216 14.4077 6.89573 14.5682C6.71815 14.4359 6.48409 14.261 6.20984 14.0564C2.80071 11.5116 0.956224 7.37073 1.31698 3.12987L6.88963 1.31383L12.6628 3.13705ZM4.37909 7.59331L6.15743 9.38576C6.27649 9.50629 6.4383 9.57398 6.60723 9.57347C6.77565 9.57347 6.93746 9.50629 7.05703 9.38576L10.6137 5.80035C10.8615 5.55007 10.8615 5.14388 10.6132 4.89412C10.3654 4.64384 9.96242 4.64384 9.71411 4.89412L6.60723 8.02617L5.27869 6.68708C5.03038 6.43681 4.62739 6.43681 4.37909 6.68708C4.13078 6.93685 4.13078 7.34355 4.37909 7.59331Z",
    fill: "#393B4A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.65197748ef1bdf9889e95250377203eb.svg";
export { ForwardRef as ReactComponent };